module.exports = __webpack_public_path__ + "static/img/20scratch.87e41919.png";